import React, { useState, useEffect } from 'react';
import { Radio, Form, notification, message, Row, Modal, Upload, Col, Input, Image, Select, Divider, Table, Button } from 'antd';
import { SearchOutlined, PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, } from '@ant-design/icons';
//import { useNavigate, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2';
import { fetchData, sendData, sendDataPut } from '../../httpRequests';
import Item from 'antd/lib/list/Item';
// const navigate = useNavigate();

const { Search } = Input;
const form = {
    name: '',
    nombre: '',

}

const CategoriesList = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [img, setImg] = useState(null)
    const [imgEdit, setImgEdit] = useState('')
    const [showCreateModal, setShowCreateModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([])
    const [formValues, setFormValues] = useState(form)
    const { id, name, nombre } = formValues
    //const [icon,setIcon] = useState('')
    const URL = '/categories/getCategories';
    const addURL = '/categories/addCategories';
   // const [selectionType, setSelectionType] = useState<'radio'>('radio');
    const [imgUploaded,setImgUploaded] = useState(false)
    const [formIsEdited, setformIsEdited] = useState(false)
    const [imgProps, setImgProps] = useState({
        uid: id,
        name: name,
        status: 'done',
        url: img,
    })
    // interface DataType {
    //     id: React.Key;
    //     name: string;
    //     nombre: string;
    //     icon: string;
    // }
    const getCategories= () => {
        fetchData(URL).then((response) => {
            if (Object.keys(response).length > 0) {
                const category = response['category'];
                setCategories(category);
                setFilteredCategories(category)
            }
        })
    }

    // const rowSelection = {
    //     onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
    //         console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    //         // setImg(selectedRows.map(a => a.icon))
    //     }
    // }
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        // {
        //     title: 'Id',
        //     dataIndex: 'id',
        //     key: 'id',
        // },
        {
            title: 'Icon',
            render: ({ icon }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={icon} />
                </div>
            )
        },
        {
            title: 'Actions',
            render: ({ id, icon, nombre, name }) => (
                <div style={{ display: 'flex' }} >
                    <span style={{ margin: 10, cursor: 'pointer' }}>
                        <EditOutlined onClick={() => { handleShowEditModal(id, name, nombre, icon) }} style={{ fontSize: '25px', color: '#128780' }} />
                    </span>

                    <span style={{ margin: 10, cursor: 'pointer' }}  >
                        <DeleteOutlined style={{ fontSize: '25px', color: 'red' }} />
                    </span>
                </div>

            )
        }
    ];

    const props = {

        listType: 'picture',
        beforeUpload(file) {
            setImg(file)
            setImgEdit(file)
            setImgUploaded(true)

        },
        // name: 'file',
        // action: '' ,
        // headers: {
        //     authorization: 'authorization-text',
        // },
        // onChange(info) {
        //     if (info.file.status === 'done') {
        //         message.success(`${info.file.name} file uploaded successfully`);
        //     } else if (info.file.status === 'error') {
        //         message.error(`${info.file.name} file upload failed.`);
        //     }

        // },

        defaultFileList: [
            {
                uid: id,
                name: name,
                status: 'done',
                url: img,
            }]


    }

    const handleShowCreateModal = () => {
        setShowCreateModal(true)
    }
    const handleShowEditModal = (id, name, nombre, Icon) => {
        setShowEditModal(true);
        const selectedRow = filteredCategories.find(a => a.id == id)
        setFormValues({name:name,nombre:nombre})
        const selectedValues = selectedRow
        setImg(Icon);
        setImgProps({
            uid: id,
            name: name,
            status: 'done',
            url: img,
        })
        setFormValues(selectedRow)
        //console.log(selectedRow)
        // console.log(selectedValues,'test')
        // console.log(columns)

    }
    const handleCancelModals = () => {
        setShowCreateModal(false);
        setShowEditModal(false)
        setFormValues(form)
        setImg(null)
    }
    const onSearch = (value) => {
        const text = value.target.value

        if (text) {
            const filteredCategories = categories.filter((category) => {
                return category.name.trim().toLowerCase().includes(text.trim().toLowerCase())// ||category.nombre.toLowerCase().includes(text.toLowerCase()) 
            });
            setFilteredCategories(filteredCategories);

        } else {
            setFilteredCategories(categories);
        }
    }
    const handleFile = async (id) => {

        const url = (window.location.hostname.includes('localhost'))
            ? `http://localhost:3003/api/categories/updateCategoryImage/${id}`
            : `https://coopharma-api-zd5is.ondigitalocean.app/api/categories/updateCategoryImage/${id}`

     
        const file = img
        const formData = new FormData();
        formData.append('image', file);
        try {
            const resp = await sendData(`/categories/updateCategoryImage/${id}`, FormData);

            if (resp.ok) {
                //const cloudResp = await resp.json();
                //console.log(cloudResp, 'response')
                getCategories()
            }
        } catch (error) {
            console.log(error, "error")
        }
        setIsLoading(false)
    }

    const handleInput = (e) => {
        setFormValues({
            ...formValues,
            [e.target.name]: e.target.value

        });
        setformIsEdited(true)
    }

    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    }
    const saveCategory = () => {
        setIsLoading(true)
        //setFormValues({ name: name, nombre: nombre });
        sendData(addURL, formValues).then(response => {
            if (response.ok) {
                //img ? console.log(img, response) : false
                openNotificationWithIcon('success', 'Category created successfully');
                handleFile(response.category.id)
                if (!isLoading) {
                    handleCancelModals();
                    //getCategories();
                }
                //console.log(response)
            }
        })
        //console.log(formValues)
    }
    const updateCategory = async () => {


        const url = `/categories/updateCategory/${id}`


        const cloudurl = `http://localhost:3001/api/categories/updateCategory/${id}`
        const data = { name: name, nombre: nombre };
        console.log(data)


        // try {
            let resp={ok:false};
            if(formIsEdited){
            resp = await sendDataPut(url, data)
            }
        // const resp = await fetch(cloudurl, {
        //     method: 'put',
        //     body: data
        // });
        console.log(resp)
        if (resp.ok) {
            getCategories();
            //console.log(resp, 'resp')
            if(imgUploaded){

                handleFile(id)
            }

            handleCancelModals();
        }
        // } catch (error) {
        //     console.log(error, "error")
        // }
    }

    useEffect(() => {
        getCategories()
    }, [])
    return (

        <>
            <Row gutter={24}>
                <Col span={20}>
                    <Search
                        size='large'
                        placeholder='Search categories'
                        onChange={onSearch}
                    />
                </Col>
                <Col span={4}>
                    <Button
                        onClick={handleShowCreateModal}
                        type='primary'
                        style={{
                            height: 40,
                            color: '#fff',
                            borderRadius: 4,
                            fontSize: 16,
                            width: 150,
                            backgroundColor: '#128780',
                            position: 'relative',
                            float: 'right',


                            marginRight: 0
                        }}
                    >Add Category</Button>
                </Col>
            </Row>
            <Row gutter={24}>

                <Col span={24}>
                    <Table 
                        dataSource={filteredCategories} rowKey={(Item) => Item.id} columns={columns} />;
                </Col>
            </Row>

            <Modal
                centered
                width={600}
                title="Add category"
                visible={showCreateModal}
                onCancel={handleCancelModals}
                footer={null}
                closable={true}
            >

                <Form>
                    <Row gutter={24} >
                        <Col span={24} style={{ padding: '15px' }}>
                            <label htmlFor=""><span style={{ color: 'red' }}>*</span> Name</label>
                            <Input
                                size='large'
                                type='text'
                                name="name"
                                value={name}
                                onChange={handleInput}
                            />
                        </Col>
                        <Col span={24} style={{ padding: '15px' }}>
                            <label htmlFor=""><span style={{ color: 'red' }}>*</span> Nombre</label>
                            <Input
                                size='large'
                                type='text'
                                name="nombre"
                                value={nombre}
                                onChange={handleInput}
                            />
                        </Col>
                        <Col span={24} className='formMarginInput'>

                            <Upload {...props} maxCount={1} >
                                {/* <label htmlFor="">Image</label> */}
                                <Button icon={<UploadOutlined />}>Upload image</Button>
                            </Upload>,
                        </Col>
                        {/* <Col span={24} className='formMarginInput'>
                        <Image src={img} style={{ width: '100px' }} />
                    </Col> */}
                        <Col span={24}>
                            <Button
                                onClick={saveCategory}
                                type='primary'
                                size='large'
                                style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                            // disabled={name.trim() == '' || nombre.trim() == ''}
                            >
                                {isLoading ? <UploadOutlined /> : <SaveOutlined />}
                                Save
                            </Button>
                        </Col>
                    </Row>
                </Form>

            </Modal>
            <Modal

                centered
                width={600}
                title="Edit category"
                visible={showEditModal}
                onCancel={handleCancelModals}
                footer={null}
                closable={true}
            >

                <Form>
                    <Row gutter={24} >
                        <Col span={24} style={{ padding: '15px' }}>
                            <label htmlFor=""><span style={{ color: 'red' }}>*</span> Name</label>
                            <Input
                                size='large'
                                type='text'
                                name="name"
                                value={name}
                                onChange={handleInput}
                            />
                        </Col>
                        <Col span={24} style={{ padding: '15px' }}>
                            <label htmlFor=""><span style={{ color: 'red' }}>*</span> Nombre</label>
                            <Input
                                size='large'
                                type='text'
                                name="nombre"
                                value={nombre}
                                onChange={handleInput}
                            />
                        </Col>
                        <Col span={24} className='formMarginInput'>

                            <Upload {...props} maxCount={1} >
                                {/* <label htmlFor="">Image</label> */}
                                <Button icon={<UploadOutlined />}>Upload image</Button>
                            </Upload>,
                        </Col>
                        {/* <Col span={24} className='formMarginInput'>
                        <Image src={img} style={{ width: '100px' }} />
                    </Col> */}
                        <Col span={24}>
                            <Button
                                onClick={updateCategory}
                                type='primary'
                                size='large'
                                style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                            // disabled={name.trim() == '' || nombre.trim() == ''}
                            >
                                {isLoading ? <UploadOutlined /> : <SaveOutlined />}
                                Save
                            </Button>
                        </Col>
                    </Row>
                </Form>

            </Modal>
        </>
    )
}

export default CategoriesList